import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    description: 'Label for the title representing the order details section',
    defaultMessage: 'Order Details',
    id: 'oe5yph',
  },
  expandableSectionAriaLabel: {
    description: 'Aria label for the expandable shipment details section',
    defaultMessage: 'Shipment Details expander section',
    id: 'RHmymS',
  },
  paidDate: {
    description: 'Label for the date that the order was paid on',
    defaultMessage: 'Paid Date',
    id: 'z3YQ7D',
  },
  orderDate: {
    description: 'Label for the date that the order was made on',
    defaultMessage: 'Order Date',
    id: '8mNS4b',
  },
  productCost: {
    description: 'Label for the cost of all products in the order',
    defaultMessage: 'Product',
    id: 'FH6jq1',
  },
  shippingCost: {
    description: 'Label for the shipping amount on the order',
    defaultMessage: 'Shipping',
    id: 'eDlROu',
  },
  taxAmount: {
    description: 'Label for the tax amount on the order',
    defaultMessage: 'Tax',
    id: 'X2seDS',
  },
  totalAmount: {
    description: 'Label for the total amount of the order',
    defaultMessage: 'Total',
    id: 'imvS+x',
  },
  totalPaid: {
    description: 'Label for the total amount paid on the order',
    defaultMessage: 'Total Paid',
    id: 'mld2Un',
  },
  costSummary: {
    description: 'Cost Summary Title',
    defaultMessage: 'Cost Summary',
    id: '4DWQ9u',
  },
  multipleShipToAddresses: {
    description: 'Text informing the user that there are multiple ship to addresses for shipments in an order.',
    defaultMessage: 'This order contains multiple Ship To Addresses',
    id: 'fLsOa9',
  },
});
